import styled from 'styled-components';
import { media } from '~src/styles/media-templates';

export const Container = styled.div`
  position: relative;
  overflow: auto;
`;

export const FilterInput = styled.div`
  flex-grow: 1;
`;

export const FilterTitle = styled.label`
  font-weight: 600;
  min-width: 240px;
  vertical-align: center;

  ::first-letter {
    text-transform: capitalize;
  }
`;

export const FilterRow = styled.div<{ $disabled?: boolean }>`
  padding: 10px 75px;
  border-bottom: 1px solid ${({ theme }) => theme.black.a1};
  display: flex;
  justify-content: center;
  opacity: ${p => (p.$disabled ? 0.7 : 1)};
  pointer-events: ${p => (p.$disabled ? 'none' : 'unset')};
  ${media.tablet`
    padding: 0 ${({ theme }) => theme.sz.pageSidePaddingS};
  `}
`;

export const HeadlineDescription = styled.div`
  font-size: 1.2rem;
  color: ${({ theme }) => theme.baseBlue.a6};
  margin-top: 5px 0px;
  transition: all 300ms;
`;

export const FilterContainer = styled.div`
  ${FilterRow}:nth-last-child(-n+2) {
    border: none;
  }
`;
